/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { EnrollmentAppStore } from "../enrollment-store/store";
import { combineReducers } from "redux";
import { enrollments } from "./enrollments";
import { invitations } from "./invitations";
import { metadata } from "./metadata";
import { bankAndTaxStatuses } from "./bank-and-tax-statuses";
import { errorStatus } from "./error-status";
import { payoutReports } from "./payout-reports";
import { dataFetchingStatus } from "./data-fetching-status";

export const reducers = combineReducers<EnrollmentAppStore>({
    enrollments,
    invitations,
    payoutReports,
    metadata,
    bankAndTaxStatuses,
    errorStatus,
    dataFetchingStatus
});
